import React, { useState, createContext, useContext } from 'react';
type Lang = 'es' | 'en';
type Dict = Record<string, {
  es: string;
  en: string;
}>;
const dict: Dict = {
  // Nav
  'nav.inicio': {
    es: 'Inicio',
    en: 'Home'
  },
  'nav.servicios': {
    es: 'Servicios',
    en: 'Services'
  },
  'nav.repertorio': {
    es: 'Repertorio',
    en: 'Repertoire'
  },
  'nav.shows': {
    es: 'Shows',
    en: 'Shows'
  },
  'nav.contacto': {
    es: 'Contacto',
    en: 'Contact'
  },
  'nav.reservar': {
    es: 'Reservar',
    en: 'Book'
  },
  // Hero
  'hero.eyebrow': {
    es: 'LIVE LATIN MUSIC · ORLANDO, FL',
    en: 'LIVE LATIN MUSIC · ORLANDO, FL'
  },
  'hero.title.1': {
    es: 'La música perfecta para hacer de tu evento un',
    en: 'The perfect music to make your event'
  },
  'hero.title.2': {
    es: 'momento inolvidable',
    en: 'an unforgettable moment'
  },
  'hero.subtitle': {
    es: 'Merengue, salsa, bachata, reguetón y boleros en vivo. Una experiencia íntima y elegante que enciende cualquier celebración.',
    en: 'Live merengue, salsa, bachata, reggaeton and boleros. An intimate, elegant experience that lights up any celebration.'
  },
  'hero.cta.primary': {
    es: 'Reservar tu evento',
    en: 'Book your event'
  },
  'hero.cta.secondary': {
    es: 'Ver servicios',
    en: 'See services'
  },
  'hero.scroll': {
    es: 'SCROLL',
    en: 'SCROLL'
  },
  // About
  'about.eyebrow': {
    es: 'SOBRE JADE',
    en: 'ABOUT JADE'
  },
  'about.title.1': {
    es: 'Voz, sabor y elegancia',
    en: 'Voice, flavor and'
  },
  'about.title.2': {
    es: 'latina',
    en: 'Latin elegance'
  },
  'about.p1': {
    es: 'Jade es la voz detrás de Jade Latin Music, una banda apasionada por llevar el alma latina a cada escenario. Desde bodas íntimas hasta lounges llenos de energía, Jade y su grupo crean atmósferas únicas en Orlando y toda Florida.',
    en: 'Jade is the voice behind Jade Latin Music, a band passionate about bringing Latin soul to every stage. From intimate weddings to high-energy lounges, Jade and her group create unique atmospheres across Orlando and Florida.'
  },
  'about.p2': {
    es: 'Cada show es una mezcla cuidada de ritmos, emoción y conexión con el público. Música en vivo que se siente, que invita a brindar, bailar y recordar.',
    en: 'Every show is a careful blend of rhythm, emotion and audience connection. Live music you feel — music that invites you to toast, dance and remember.'
  },
  'about.stat1.value': {
    es: '+100',
    en: '+100'
  },
  'about.stat1.label': {
    es: 'Eventos en vivo',
    en: 'Live events'
  },
  'about.stat2.value': {
    es: '10+',
    en: '10+'
  },
  'about.stat2.label': {
    es: 'Años de experiencia',
    en: 'Years of experience'
  },
  'about.stat3.value': {
    es: '100%',
    en: '100%'
  },
  'about.stat3.label': {
    es: 'Música en vivo',
    en: 'Live music'
  },
  // Services
  'services.eyebrow': {
    es: 'SERVICIOS',
    en: 'SERVICES'
  },
  'services.title.1': {
    es: 'Música en vivo para cada',
    en: 'Live music for every'
  },
  'services.title.2': {
    es: 'ocasión',
    en: 'occasion'
  },
  'services.bodas.title': {
    es: 'Bodas',
    en: 'Weddings'
  },
  'services.bodas.desc': {
    es: 'Una banda sonora inolvidable para el día más importante de tu vida.',
    en: 'An unforgettable soundtrack for the most important day of your life.'
  },
  'services.corp.title': {
    es: 'Eventos Corporativos',
    en: 'Corporate Events'
  },
  'services.corp.desc': {
    es: 'Música en vivo que eleva galas, lanzamientos y celebraciones de empresa.',
    en: 'Live music that elevates galas, launches and company celebrations.'
  },
  'services.rest.title': {
    es: 'Restaurantes & Lounges',
    en: 'Restaurants & Lounges'
  },
  'services.rest.desc': {
    es: 'Ambientes elegantes con shows en vivo que enamoran a tus clientes.',
    en: 'Elegant atmospheres with live shows that delight your guests.'
  },
  'services.party.title': {
    es: 'Fiestas Privadas',
    en: 'Private Parties'
  },
  'services.party.desc': {
    es: 'Cumpleaños, aniversarios y reuniones llenas de ritmo latino.',
    en: 'Birthdays, anniversaries and gatherings full of Latin rhythm.'
  },
  // Repertoire
  'rep.eyebrow': {
    es: 'REPERTORIO',
    en: 'REPERTOIRE'
  },
  'rep.title.1': {
    es: 'Ritmos que',
    en: 'Rhythms that'
  },
  'rep.title.2': {
    es: 'enamoran',
    en: 'enchant'
  },
  // Shows
  'shows.eyebrow': {
    es: 'PRÓXIMOS SHOWS',
    en: 'UPCOMING SHOWS'
  },
  'shows.title.1': {
    es: 'Febrero',
    en: 'February'
  },
  'shows.title.2': {
    es: '2026',
    en: '2026'
  },
  'shows.subtitle': {
    es: 'Música en vivo · Florida',
    en: 'Live music · Florida'
  },
  'shows.month': {
    es: 'FEB',
    en: 'FEB'
  },
  // Gallery
  'gallery.eyebrow': {
    es: 'GALERÍA',
    en: 'GALLERY'
  },
  'gallery.title.1': {
    es: 'Momentos en',
    en: 'Moments on'
  },
  'gallery.title.2': {
    es: 'escena',
    en: 'stage'
  },
  // Contact
  'contact.eyebrow': {
    es: 'CONTACTO',
    en: 'CONTACT'
  },
  'contact.title.1': {
    es: 'Hagamos de tu evento algo',
    en: "Let's make your event"
  },
  'contact.title.2': {
    es: 'inolvidable',
    en: 'unforgettable'
  },
  'contact.intro': {
    es: 'Cuéntanos sobre tu evento y te responderemos en menos de 24 horas con disponibilidad y propuesta.',
    en: "Tell us about your event and we'll get back to you within 24 hours with availability and a proposal."
  },
  'contact.response': {
    es: 'Respondemos en menos de 24 horas.',
    en: 'We reply in under 24 hours.'
  },
  'contact.form.name': {
    es: 'NOMBRE',
    en: 'NAME'
  },
  'contact.form.name.ph': {
    es: 'Tu nombre',
    en: 'Your name'
  },
  'contact.form.email': {
    es: 'EMAIL',
    en: 'EMAIL'
  },
  'contact.form.phone': {
    es: 'TELÉFONO',
    en: 'PHONE'
  },
  'contact.form.date': {
    es: 'FECHA DEL EVENTO',
    en: 'EVENT DATE'
  },
  'contact.form.type': {
    es: 'TIPO DE EVENTO',
    en: 'EVENT TYPE'
  },
  'contact.form.type.placeholder': {
    es: 'Selecciona una opción',
    en: 'Select an option'
  },
  'contact.form.type.boda': {
    es: 'Boda',
    en: 'Wedding'
  },
  'contact.form.type.corp': {
    es: 'Corporativo',
    en: 'Corporate'
  },
  'contact.form.type.bday': {
    es: 'Cumpleaños',
    en: 'Birthday'
  },
  'contact.form.type.rest': {
    es: 'Restaurante / Lounge',
    en: 'Restaurant / Lounge'
  },
  'contact.form.type.other': {
    es: 'Otro',
    en: 'Other'
  },
  'contact.form.message': {
    es: 'MENSAJE',
    en: 'MESSAGE'
  },
  'contact.form.message.ph': {
    es: 'Cuéntanos sobre tu evento...',
    en: 'Tell us about your event...'
  },
  'contact.form.submit': {
    es: 'Enviar solicitud',
    en: 'Send request'
  },
  'contact.form.sending': {
    es: 'Enviando...',
    en: 'Sending...'
  },
  'contact.toast': {
    es: '¡Gracias! Jade te contactará pronto.',
    en: 'Thanks! Jade will contact you soon.'
  },
  // Footer
  'footer.tagline': {
    es: '"La música perfecta para tu evento."',
    en: '"The perfect music for your event."'
  },
  'footer.rights': {
    es: 'Todos los derechos reservados.',
    en: 'All rights reserved.'
  }
};
type Ctx = {
  lang: Lang;
  setLang: (l: Lang) => void;
  t: (key: string) => string;
};
const LanguageContext = createContext<Ctx | null>(null);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [lang, setLang] = useState<Lang>('es');
  const t = (key: string) => dict[key]?.[lang] ?? key;
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t
  }} data-id="element-121">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
}